const SuccessModal = require('./success_modal.jsx');
const { mapStateToProps } = require('@reverbdotcom/discovery-ui');
const CartStore = require('components/cart/cart_store');

function mapper() {
  const { cart } = CartStore.getState();

  return { cart };
}

module.exports = mapStateToProps({
  mapper, stores: [CartStore],
})(SuccessModal, 'SuccessModal');



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/success_modal_container.jsx